export interface AuthProps {
  updateFormType: (type: FormType) => void;
}

export enum FormType {
  FORGOT_PASSWORD,
  LOADING,
  SIGN_IN,
  SIGN_UP,
  SEPA_CONFIGURATION,
}
